import React, { ReactElement, useCallback } from 'react';
import { animateScroll } from 'react-scroll/modules';
import isEqual from 'lodash.isequal';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

const SCROLL_DELAY = 300;

const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const {
      onPageChange,
      ...originalProps
    } = props;

    const handlePaginationClick = useCallback(
      (page: number): void => {
        animateScroll.scrollToTop({
          duration: SCROLL_DELAY,
        });
        setTimeout(
          () => onPageChange(page),
          SCROLL_DELAY,
        );
      },
      [onPageChange],
    );

    const injectedProps: InjectedProps = {
      handlePaginationClick,
    };

    return <Component {...originalProps} {...injectedProps} />;
  };

  return React.memo(
    WithContainer,
    (prevProps, nextProps) => {
      switch (true) {
        case prevProps.total !== nextProps.total:
        case prevProps.page !== nextProps.page:
        case !isEqual(prevProps.onPageChange, nextProps.onPageChange):
          return false;

        default:
          return true;
      }
    },
  );
};

export { withContainer };
